import { ROOT, GET_LIST_GIFT_CODE, CREAT_GIFT_CODE, DETAIL_GIFT_CODE, DELETE_GIFT_CODE, UPDATE_GIFT_CODE, SEARCH_AGENT, GET_PAYMENT_GATE } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

// export const GET_LIST_GIFT_CODE = "/api/v2/hotel/giftcode/search";
// export const CREAT_GIFT_CODE = "/api/v2/hotel/giftcode/create";
// export const DELETE_GIFT_CODE = "/api/v2/hotel/giftcode/delete";
// export const DETAIL_GIFT_CODE = "/api/v2/hotel/giftcode/detail";

function getList(body) {
  return fetch(ROOT + GET_LIST_GIFT_CODE, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function searchAgent(body) {
  return fetch(ROOT + SEARCH_AGENT, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function creat(body) {
  return fetch(ROOT + CREAT_GIFT_CODE, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function update(body) {
  return fetch(ROOT + UPDATE_GIFT_CODE, requestOptions.post(body))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function detail(body) {
  return fetch(ROOT + DETAIL_GIFT_CODE + `/${body}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function remove(id) {
  return fetch(ROOT + DELETE_GIFT_CODE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getPaymentGate() {
  return fetch(ROOT + GET_PAYMENT_GATE, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
export const giftCodeService = {
  getList,
  creat,
  detail,
  remove,
  update,
  searchAgent,
  getPaymentGate
};
